'use es6';

import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { jsx as _jsx } from "react/jsx-runtime";
const BlogPreviewRouteContainer = () => /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
  children: ({
    PagesPreviewModalContainer
  }) => /*#__PURE__*/_jsx(PagesPreviewModalContainer, {})
});
export default BlogPreviewRouteContainer;